import { MapLocation } from 'shared/types';
import { Place, PlaceAddress } from 'features/places/places.types';

export const mapLocationToPlaceAddress = (
  location: MapLocation,
): PlaceAddress => {
  return {
    name: location.name,
    formattedAddress: location.formattedAddress ?? '',
    coordinates: {
      latitude: location.lat,
      longitude: location.lng,
    },
    bbox: location.bbox,
    type: location.type,
  };
};

export const placeLocationToMapLocation = (place: Place): MapLocation => {
  return {
    name: place.name,
    lat: place.address.coordinates.latitude,
    lng: place.address.coordinates.longitude,
    bbox: place.address.bbox,
    place: true,
  };
};
